import React from 'react';
import SectionTitle from '../../../components/SectionTitle';
import { HashLink as Link } from 'react-router-hash-link';
import { StyledExpertsCTO } from './styles/StyledExpertsCTO';

const ExpertsCTO = ({ content, bgColor }) => {
  return (
    <StyledExpertsCTO style={{ backgroundColor: bgColor }}>
      <div className="decor-relative-anchor">
        <div className="rn-section-gap">
          <div className="container">
            <div className="decor-images-wrapper-1">
              <img className="decor-image-1" src={content.twoImagesDecor.image1.src} alt={content.twoImagesDecor.image1.alt} />
              <img className="decor-image-2" src={content.twoImagesDecor.image2.src} alt={content.twoImagesDecor.image2.alt} />
            </div>
            <SectionTitle {...content.sectionTitle} />
            <Link to='/#accurate-testing' className="text-button text-block-2">See Our Tests Here</Link>
          </div>
        </div>
        <div className="decor-images-wrapper-2">
          <img className="decor-image-1" src={content.twoImagesDecor2.image1.src} alt={content.twoImagesDecor2.image1.alt} />
          <img className="decor-image-2" src={content.twoImagesDecor2.image2.src} alt={content.twoImagesDecor2.image2.alt} />
        </div>
      </div>
    </StyledExpertsCTO>
  );
};

export default ExpertsCTO;
